import { useStore } from "@state/store"
import { useEffect } from "react"
import styled from "styled-components/macro"

const Info1 = ({ children }) => {
  const syncState = useStore((s) => s.syncState)

  useEffect(() => {
    syncState({
      contentControls: {
        index: 0,
      },
    })
  }, [])

  return <Wrapper>{children}</Wrapper>
}

export default Info1

const Wrapper = styled.div`
  z-index: 9999;
  width: 100%;
  height: 100%;
  display: flex;
  background-color: var(--primary);
`
